import { useEffect, useState } from "react";

export default function useMediaQuery(query: string): boolean {
  const getMatches = (mediaQuery: string): boolean => {
    // Prevents SSR issues

    if (typeof window !== "undefined") {
      return window.matchMedia(mediaQuery).matches;
    }

    return false;
  };

  const [matches, setMatches] = useState<boolean>(getMatches(query));

  function handleChange() {
    setMatches(getMatches(query));
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    const isOldBrowser = !matchMedia.addEventListener;
    // Triggered at the first client-side load and if query changes

    handleChange();

    // Listen matchMedia

    if (isOldBrowser) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }

    return () => {
      if (isOldBrowser) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);

  return matches;
}
